export default __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.7eabf102.woff2";